import injectCustomHtml from './inject-custom-html';
import ejectCustomHtml from './eject-custom-html';

export default {
  ejectCustomHtml,
  injectCustomHtml,
};
